import { Injectable } from '@angular/core';
import { Config } from '@config';
import { AuthHttp } from '@http';
import { UrlEnhancerService } from '@url';
import { lastValueFrom } from 'rxjs';


export interface CodeResponseMessage {
    message : string
    type : 'error' | 'info'
}
 

@Injectable()
export class ScriptingEditorService {
    constructor(
        private config: Config,
        private urlEnhancer: UrlEnhancerService,
        private http: AuthHttp
    ){}


    convertMessages(messages) {
        const logs: string[] = [];
        const errors = []
        messages.forEach((entry) => {
            const type = entry.level.toLowerCase();
            const prefix = type === 'error' ? 'Error: ' : 'Log: '
            if(type === 'error') {
                errors.push({ msg: prefix + entry.message, line: entry.lineNo })
            }else{
                logs.push(prefix + entry.message)
            }
            return {
                message : prefix + entry.message,
                type
            }
        })

        return {logs, errors}
    }

    generateMessageOutput(messages){
        const output = [];
        if(messages.logs.length) {
            output.push({
                type : 'info',
                message : messages.logs.join('\n')
            })
        }
        if (messages.errors.length) {
            
            output.push({
                type : 'error',
                message: messages.errors.map((e) => { return e.msg; }).join('\n'),
                lines: messages.errors.map((e) => { return e.line; })
            })
        }
        return output;
    }

    async executeScript(data: { plantScript: string, plantId?: string, systemId?: string, alarms?: any[], traceApiCalls?: boolean }): Promise<CodeResponseMessage[]>{
        const result = await lastValueFrom(this.http.postJSON(
            this.urlEnhancer.replaceParams(this.config.services.scripting.executeScript),
            data
        ))

        const messages = this.convertMessages(result?.output)
        return this.generateMessageOutput(messages);
    }


    createUcfFile(scriptValue: string, filename: string){
        const header = '::UCFFile::\r\nDeviceID=0\r\nTYPE=0x12\r\nFileName=' + filename + '\r\nEND\r\n'
        scriptValue = scriptValue.replace(/\r?\n/g, '\r\n');
        const blob = new Blob([header + scriptValue], {type: 'text/plain'});
        return blob;
    }
}